import { MIGRATOR_ZAP } from '@/domain/migrate';
import MigrateVToken from './MigrateVToken';
import { getChainConstant } from 'nftx.js';
import { useNftx } from '@nftx/react';
import useAddress from '@/application/read/web3/useAddress';
import useV2Position from '@/application/read/migrate/useV2Position';
import { useEffect, useState } from 'react';
import { V2Position } from '@/core/migrate';
import useV2Vaults from '@/application/read/migrate/useV2Vaults';
import useVault from '@/application/read/vaults/useVault';
import useMigrateVtoken from '@/application/write/migrate/useMigrateVToken';
import { useModalContext } from '@/presentation/context/modal';
import MigrateVTokenSuccess from './MigrateVTokenSuccess';
import { useNetwork } from '@/presentation/context/network';

export type Props = {
  positionId: string;
  v3VaultId: string;
};

const MigrateVTokenContainer = ({ positionId, v3VaultId }: Props) => {
  const { chain } = useNetwork();
  const [success, setSuccess] = useState(false);
  const { showMigrateModal, closeModal } = useModalContext();
  const { network } = useNftx();
  const userAddress = useAddress();
  const { data } = useV2Position({ positionId, userAddress });
  const [position, setPosition] = useState<V2Position>();
  useEffect(() => {
    if (data) {
      setPosition(data);
    }
  }, [data]);
  const { data: v2Vaults } = useV2Vaults();
  const v2Vault = v2Vaults?.find(
    (vault) => vault.vaultId === position?.vaultId
  );
  const { data: v3Vault } = useVault({ vaultId: v3VaultId });
  const [migrate, { status, error, data: txData }] = useMigrateVtoken();
  const onCancel = () => {
    showMigrateModal({ positionId });
  };
  const onComplete = () => {
    setSuccess(true);
  };

  if (success) {
    return (
      <MigrateVTokenSuccess
        chain={chain}
        transaction={txData?.transaction}
        onClose={() => closeModal()}
      />
    );
  }

  if (!position || !v2Vault || !v3Vault) {
    return null;
  }

  return (
    <MigrateVToken
      error={error}
      onCancel={onCancel}
      onComplete={onComplete}
      onMigrate={() => migrate({ position, v2Vault, v3Vault })}
      spenderAddress={getChainConstant(MIGRATOR_ZAP, network)}
      tokenAddress={v2Vault.id}
      status={status}
      v2VaultSymbol={v2Vault.token.symbol}
      v3VaultSymbol={v3Vault.token.symbol}
    />
  );
};

export default MigrateVTokenContainer;
